import axios, { AxiosRequestConfig } from "axios";
import getAxiosConfig from "../other/axiosConfig";

const changePasswordHelper = async (password: string, tokenUrl: string) => {
  const config: AxiosRequestConfig = getAxiosConfig(
    "PATCH",
    `/users-auth/change-password/${tokenUrl}`,
    "Content-Type",
    { password },
  );

  const response = await axios(config);

  const { data } = response;
  const { code } = data;

  if (code !== 200) {
    throw Error("Change password failed!");
  }
};

export default changePasswordHelper;
